import { create } from 'zustand'
import type { Language, ResolvedSessionCreated } from '@/types/join'

interface JoinStore {
  connectionId: string | null
  setConnectionId: (id: string) => void
  bearer: string | null
  bearerExpiresAt: string | null
  resolved: ResolvedSessionCreated | null
  // Raw resolve token from the join URL (?t=). Kept so an aborted interview
  // can re-open the same link ( /j/:id?t= ) to restart from the top — the URL
  // on later screens (/setup, /interview, /thankyou) no longer carries it.
  token: string | null
  selectedLanguage: Language | null
  selectedAvatarIndex: number | null
  livekitConn: { url: string; token: string } | null

  setResolved: (r: ResolvedSessionCreated) => void
  setToken: (token: string) => void
  setSelected: (language: Language, avatarIndex: number) => void
  setLivekitConn: (url: string, token: string) => void
  reset: () => void
}

export const useJoinStore = create<JoinStore>((set) => ({
  connectionId: null,
  setConnectionId: (connectionId) => set({ connectionId }),
  bearer: null,
  bearerExpiresAt: null,
  resolved: null,
  token: null,
  selectedLanguage: null,
  selectedAvatarIndex: null,
  livekitConn: null,

  setResolved: (r) => set({
    resolved: r,
    bearer: r.bearer,
    bearerExpiresAt: r.bearerExpiresAt,
  }),
  setToken: (token) => set({ token }),
  setSelected: (language, avatarIndex) => set({
    selectedLanguage: language, selectedAvatarIndex: avatarIndex,
  }),
  setLivekitConn: (url, token) => set({ livekitConn: { url, token } }),
  reset: () => set({
    connectionId: null,
    bearer: null,
    bearerExpiresAt: null,
    resolved: null,
    token: null,
    selectedLanguage: null,
    selectedAvatarIndex: null,
    livekitConn: null,
  }),
}))
